import styled from 'styled-components';
import { Icon, Text } from '@amzn/storm-ui';
import { KeyValueAttribute, LinkAttribute } from '@amzn/storm-ui-page-header';

export const APIFailureIcon = styled(Icon)`
  color: ${({ theme }) => theme.color.red[800]};
  margin-left: 5px;
`;

export const KeyText = styled(Text)`
  margin-inline-end: 3px;
`;

export const StyledKeyValueAttribute = styled(KeyValueAttribute)`
  & a {
    color: ${({ theme }) => theme.link.color.default};
  }

  & label {
    padding: 0;
  }
`;

export const StyledLinkAttribute = styled(LinkAttribute)`
  && {
    color: ${({ theme }) => theme.link.color.default};
  }
`;
